/* eslint-disable react/prop-types */
import React, {useState, FunctionComponent, useEffect} from "react";
import {
    Container,
    Box,
    Grid,
    Button,
    makeStyles,
    Dialog,
    Typography,
    CircularProgress, DialogTitle, DialogContent, DialogActions, useMediaQuery
} from "@material-ui/core";
import moment from "moment";
import Navigation from "../../../Components/Navigation";
import AppointmentsInnerNavigation from "../../../Components/Navigation/AppointmentsInnerNavigation";
import AppointmentCardContainer from "../../../Components/AppointmentCardContainer";
import UpcomingAppointmentModifyModal from "../../../Components/Modals/UpdcomingAppointmentModify";
import API from "../../../helpers/apiHelpers";
import {CancelAppointment, AnimalProfile, MedicalRecordsModal} from "../../../Components";
import {getAppointmentType} from "../../../Constants/serviceType";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import RecordListItem from "../../../Components/ListItems/RecordListItem";
import {colorInputBorder, colorInputBorderGrayish} from "../../../Constants/theme";
import {
    getPendingAppointments, loadMoreFutureAppointments,
    setFutureAppointments,
} from "../../../redux/appointmentList/appointmentList.actions";
import {getAppointment, getAppointmentNotes} from "../../../redux/appointment/appointment.actions";
import {useSnackbar} from "notistack";
import {SRLWrapper} from "simple-react-lightbox";
import {useTheme} from "@material-ui/core/styles";
import ReactWebMediaPlayer from "react-web-media-player";
import {updateShowVideo} from "../../../redux/images/images.actions";
import InfiniteScroll from "react-infinite-scroll-component";
import PusherApptList from "../../../helpers/appointmentListHelper";
import {setUpcomingAppointments} from "../../../redux/appointmentList/appointmentList.reducers";
import {useHistory, useLocation} from "react-router-dom";

interface Props {
    isOngoing?: boolean
}

const useStyle = makeStyles((theme) => ({
    buttons: {
        width: 184,
        marginBottom: 10,
        marginRight: 13,
    },
    imageModal: {
        height: "auto",
    },
    itemDivider: {
        borderBottom: `1px solid ${colorInputBorderGrayish}`
    },
    actions: {
        paddingLeft: "24px"
    },
    dialog: {
        padding: "30px 0 30px 25px",
        width: "900px"
    },
    videoDialog: {
        "& .MuiDialog-paper": {
            overflowY: "hidden",
        },
        "& .MuiDialog-paperFullWidth": {
            width: "unset",
        },
    },
    appointmentsContainer: {
        display: "flex",
        flexDirection: "column",
    },
    list: {
        height: "calc(100vh - 170px)",
        flexGrow: 1,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
            width: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            background: colorInputBorder,
            borderRadius: "6px",
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
        },
        [theme.breakpoints.down("sm")]: {
            height: "calc(100vh - 250px)",
        },
    }
}));

const lightBoxOptions = {
    settings: {
        autoplaySpeed: 0,
        downloadedFileName: "image"
    },
    thumbnails: {
        showThumbnails: false
    },
    buttons: {
        showNextButton: false,
        showPrevButton: false,
    }
};

const UpcomingAppointments: FunctionComponent<Props> = (({isOngoing}) => {
    const classes = useStyle();
    const [vetIds, setVetIds] = useState([]);
    const [vetProfiles, setVetProfiles] = useState([]);
    const [isModalVisible, setModalVisibility] = useState(false);
    const [openProfileModal, setOpenProfileModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openChatDialog, setOpenChatDialog] = useState(false);
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openNotesModal, setOpenNotesModal] = useState(false);
    const [openRecordsModal, setOpenRecordsModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState();
    const [chatData, setChatData] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [recordsList, setRecordsList] = useState(null);
    const user = useSelector((state: RootState) => state?.user);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const upcomingAppointments = useSelector((state: RootState) => state?.appointmentList.upcomingAppointments);
    const appointment = useSelector((state: RootState) => state?.appointment.appointment);
    const imageObj = useSelector((state: RootState) => state?.images.images);
    const showVideo = useSelector((state: RootState) => state?.images.showVideo);
    const animalId = useSelector((state: RootState) => state?.appointment.appointment.animal?.id);
    const dispatch = useAppDispatch();
    const todayDate = new Date();
    const pathState = useLocation();
    const history = useHistory();
    const date = todayDate.toJSON();
    const {enqueueSnackbar} = useSnackbar();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    let xs = useMediaQuery("(max-width:320px)");
    const iOS = () => {
        return [
            "iPhone Simulator",
            "iPod Simulator",
            "iPhone",
            "iPod",
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    };
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const paramsPENDING = {
        offset: offset,
        limit: 20,
    };
    const updateAppointmentList = () => {
        const pending = dispatch(getPendingAppointments(paramsPENDING));
        return pending
            .then(values => {
                setHasMore(values.length > 0);
                let requestMode = values.map(({appointment, appointmentRequestList, paidTotalAmount}) => {
                    const appList = appointmentRequestList
                        // fast fix (should be fixed in future
                        .filter(({scheduledDate}) => {
                            return moment(scheduledDate).add(3, "hour") > moment();
                        })
                        .map(({scheduledDate, id}) => ({
                            ...appointment,
                            paidTotalAmount,
                            scheduledDate: appointment?.scheduledDate || scheduledDate,
                            pending: appointment.status === "REQUEST_MADE" ? true : false,
                            id: appointment.id,
                        }));
                    return [...appList];
                });
                requestMode = requestMode.reduce((acum, curent) => {
                    acum = [...acum, ...curent];
                    return acum;
                }, []);
                const data = [...requestMode].reduce((acum, curent) => {
                    const resAcun = acum.map(({id}) => id);
                    const {id} = curent;
                    if (!resAcun.includes(id)) {
                        acum.push(curent);
                    }
                    return acum;
                }, []).sort((curr, prev) => {
                    return new Date(curr.scheduledDate).getTime() - new Date(prev.scheduledDate).getTime();
                });
                if (offset === 0) {
                    dispatch(setFutureAppointments(data));
                } else {
                    dispatch(loadMoreFutureAppointments(data));
                }
                const vetIds = data.map(({vetUserId}) => vetUserId);
                const setVets = new Set(vetIds);
                const vetArrayResult = Array.from(setVets);
                setVetIds(vetArrayResult);
                setIsLoading(false);
            })
            .catch(console.log)
            .finally(() => {
                setOffset(prev => prev + 20);
            });
    };

    useEffect(() => {
        if (pathState.state === "future") {
            history.replace({state: undefined});
            enqueueSnackbar("It’s not yet time for your appointment. You will be able to join 5 minutes before the appointment start time.", {variant: "error"});
        }
        if (pathState.state === "notExist") {
            history.replace({state: undefined});
            enqueueSnackbar("There’s an issue with joining the appointment. Please contact hello@thevideovets.com.", {variant: "error"});
        }
        setIsLoading(true);
        updateAppointmentList()
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        if (openChatDialog) {
            const onShowDialog = () => {
                setTimeout(() => {
                    if (document.querySelector(".MuiDialog-container")) {
                        document.querySelector(".MuiDialog-container").removeAttribute("tabindex");
                        return;
                    } else {
                        onShowDialog();
                    }
                }, 2000);
            };
            onShowDialog();
        }
    }, [openChatDialog]);

    const updateEventHandler = (id, appointments) => {
        let apptToUpdateIdx = appointments.findIndex((el) => el.id === id);
        let updatedAppts = [...appointments];
        getAppointment(id).then((appt) => {
            updatedAppts[apptToUpdateIdx] = appt;
            dispatch(setUpcomingAppointments(updatedAppts));
        });

    };

    const subscriber = pusherApptList => {
        pusherApptList.bind(PusherApptList.EVENT_UPDATE, function ({message, appointmentId: id}) {
            updateEventHandler(id, upcomingAppointments);
        });
    };

    const unSubscriber = pusherApptList => {
        PusherApptList.unsubscribeChannel(user.userId);
        if (pusherApptList) {
            pusherApptList.unbind(PusherApptList.EVENT_UPDATE);
        }
    };

    useEffect(() => {
        // updateAppointmentList();
        const list = PusherApptList.subscribeChannel(user.userId);
        if (list) {
            subscriber(list);
            return () => unSubscriber(list);
        }
    }, [upcomingAppointments]);

    const getNotesForAppointment = async (id) => {
        setSelectedAppointment(id);
        setIsLoading(true);
        setOpenRecordsModal(true);
        try {
            const records = await dispatch(getAppointmentNotes(
                user.role === "OWNER" ?
                    {appointmentId: id} : {animalId: id}
            ));
            setRecordsList(records);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (vetIds.length !== 0) {
            const vetProfilePromises = vetIds.map(item => {
                if (!item) {
                    return "";
                } else {
                    return API.getProfiles({userId: item});
                }
            });
            Promise.all(vetProfilePromises)
                .then(values => {
                    let vetProfileArray = [];
                    values.forEach(item => vetProfileArray = [...vetProfileArray, ...item]);
                    setVetProfiles(vetProfileArray);
                    setIsLoading(false);
                })
                .catch(console.error)
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [vetIds]);

    const handleChatData = (open, data, over) => {
        if (open) {
            setOpenChatDialog(true);
            setChatData({data, over});
        } else {
            setOpenChatDialog(false);
            setChatData({});
        }
    };

    const handleCloseTranscript = () => {
        setOpenChatDialog(false);
        setChatData({});
    };

    return (
        <Box>
            <Container maxWidth="md">
                <Box marginTop={isMobile ? "50px" : "100px"}>
                    <Grid container>
                        {!isMobile &&
                        <Grid item md={3} xs={12}>
                            <Navigation/>
                        </Grid>
                        }
                        <Grid item md={9} xs={12} className={classes.appointmentsContainer}>
                            <AppointmentsInnerNavigation/>
                            <Box
                                id="scrollableDiv"
                                className={classes.list}
                                style={{height: iOS() ? "calc(100vh - 295px)" : isMobile ? "calc(100vh - 240px)" : "",}}
                            >
                                {
                                    isLoading ?
                                        <Box width="100%" height="300px" display="flex" justifyContent="center"
                                            alignItems="center">
                                            <CircularProgress/>
                                        </Box>
                                        :
                                        upcomingAppointments.length !== 0 ?
                                            <InfiniteScroll
                                                dataLength={upcomingAppointments.length}
                                                next={updateAppointmentList}
                                                hasMore={hasMore}
                                                loader={
                                                    <Box width="100%" height="300px" display="flex"
                                                        justifyContent="center"
                                                        alignItems="center">
                                                        <CircularProgress/>
                                                    </Box>
                                                }
                                                scrollableTarget="scrollableDiv"
                                            >
                                                {
                                                    upcomingAppointments.map(item => (
                                                        <AppointmentCardContainer
                                                            key={item.id}
                                                            item={item}
                                                            vetProfiles={vetProfiles}
                                                            setModalVisibility={setOpenCancelModal}
                                                            setModalProfile={setOpenProfileModal}
                                                            showNotes={getNotesForAppointment}
                                                        />)
                                                    )

                                                }
                                            </InfiniteScroll>
                                            :
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="flex-start"
                                                mt={2}
                                            >
                                                <Typography gutterBottom>
                                                    No upcoming appointments
                                                </Typography>

                                                {user.role !== "VET" && (
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => history.push("/schedule")}
                                                    >
                                                        Book Now
                                                    </Button>
                                                )}
                                            </Box>
                                }
                            </Box>

                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <CancelAppointment isOpen={openCancelModal} setOpenDialog={setOpenCancelModal} item={appointment}/>
            <AnimalProfile
                isOpen={openProfileModal}
                setModalProfile={setOpenProfileModal}
            />
            <UpcomingAppointmentModifyModal
                onClose={() => {
                    setModalVisibility(false);
                }}
                isOpen={isModalVisible}
            />
            <SRLWrapper
                elements={imageObj}
                options={lightBoxOptions}
            />
            <Dialog
                fullWidth={true}
                disableEnforceFocus
                className={classes.videoDialog}
                onClose={() => dispatch(updateShowVideo(false))}
                open={showVideo}
            >
                <ReactWebMediaPlayer
                    style={{marginBottom: 0,}}
                    video={imageObj[0].src}
                />
            </Dialog>
            <Dialog
                open={openRecordsModal}
                disableEnforceFocus
                onClose={() => {
                    setOpenRecordsModal(false);
                    setRecordsList(null);
                }}
                classes={{paper: classes.dialog}}
                scroll="body"
            >
                <DialogTitle color="primary">
                    <Typography variant="h3">
                        Medical Records
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {isLoading ?
                        <Box width="100%" height="300px" display="flex" justifyContent="center" alignItems="center">
                            <CircularProgress/>
                        </Box>
                        : (recordsList?.length && vetProfiles?.length) ?
                            [...recordsList]
                                .sort((a, b) => moment(b.created).diff(moment(a.created)))
                                .map(({id, created, appointment}, idx) => {
                                    const vet = vetProfiles.find(profile => profile.userId === appointment?.vetUserId);
                                    const title = appointment.status === "NOT_APPLICABLE" ? "In-Clinic Appointment" : `${getAppointmentType(appointment?.type)} ${vet?.lastName? (`- Dr. ${vet.lastName}`) : ""}`;
                                    const noteCreated = moment(created).format("MMMM DD, YYYY");
                                    return <RecordListItem
                                        key={idx}
                                        id={id}
                                        title={title}
                                        date={noteCreated}
                                        setSelectedRecord={setSelectedRecord}
                                        setOpenModal={setOpenNotesModal}
                                        styles={(idx === recordsList.length - 1) ? "" : classes.itemDivider}
                                    />;
                                })
                            :
                            <Typography variant="h6">No medical records</Typography>}
                </DialogContent>
                <DialogActions classes={{root: classes.actions}}
                >
                    <Box display="flex" justifyContent="flex-start" width="100%">
                        <Button type="button" variant="contained"
                            onClick={() => {
                                setOpenRecordsModal(false);
                                setRecordsList(null);
                            }}>
                            Close
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <MedicalRecordsModal isOpen={openNotesModal} setOpenDialog={setOpenNotesModal} noteId={selectedRecord}/>
        </Box>
    );
});

export default UpcomingAppointments;
